import { systemChannelType } from './system-channels';

export enum ChannelType {
    DIGITAL_CONTACT = 1,
    DIGITAL_MOTOR = 2,
    DIGITAL_EXT_COMM = 3,
    DIGITAL_LOGIC = 4,

    ANALOG_420MA_PT = 21,
    ANALOG_420MA_AI = 22,
    ANALOG_1_5_V = 23,
    ANALOG_PT100_3WIRE = 24,
    ANALOG_PT100_2WIRE = 25,
    ANALOG_TEMP_K = 26,
    ANALOG_EXT_COMM = 27,
    ANALOG_LOGIC = 28,

    EXH_GAS_DEV = 31,
    EXH_GAS_MEAN = 32,

    FLOW_TOTAL = 41,
    FLOW_DAY = 42,
    FLOW_EXT_COMM = 43,
    FLOW_LOGIC = 44,

    RUNNING_TOTAL = 51,
    RUNNING_DAY = 52,
    RUNNING_LOGIC = 53,

    BLANK = 100,

    SYSTEM = 200,

    BLANK_FCU = 300,
}

export enum MotorChannelType {
    RUN = 1,
    RUN_A = 2,
    RUN_B = 3,
    RUN_C = 4,
    RUN_D = 5,
    RUN_E = 6,
    RUN_F = 7,
    RUN_G = 8,
    RUN_H = 9,
    RUN_I = 10,
    RUN_J = 11,
    RUN_K = 12,
}

export const ChannelTypeStrings = {};
ChannelTypeStrings[ChannelType.DIGITAL_CONTACT] = 'Digital (contact)';
ChannelTypeStrings[ChannelType.DIGITAL_MOTOR] = 'Digital (Motor)';
ChannelTypeStrings[ChannelType.DIGITAL_EXT_COMM] = 'Digital (Ext Comm.)';
ChannelTypeStrings[ChannelType.DIGITAL_LOGIC] = 'Digital (Logic)';

ChannelTypeStrings[ChannelType.ANALOG_420MA_AI] = 'Analog (4-20mA AI)';
ChannelTypeStrings[ChannelType.ANALOG_420MA_PT] = 'Analog (4-20mA PT)';
ChannelTypeStrings[ChannelType.ANALOG_1_5_V] = 'Analog (1-5V)';
ChannelTypeStrings[ChannelType.ANALOG_PT100_3WIRE] = 'Analog (Temp Pt100 3-wire)';
ChannelTypeStrings[ChannelType.ANALOG_PT100_2WIRE] = 'Analog (Temp Pt100 2-wire)';
ChannelTypeStrings[ChannelType.ANALOG_TEMP_K] = 'Analog (Temp K)';
ChannelTypeStrings[ChannelType.ANALOG_EXT_COMM] = 'Analog (Ext Comm.)';
ChannelTypeStrings[ChannelType.ANALOG_LOGIC] = 'Analog (Logic)';

ChannelTypeStrings[ChannelType.EXH_GAS_DEV] = 'Exh gas dev';
ChannelTypeStrings[ChannelType.EXH_GAS_MEAN] = 'Exh gas mean';

ChannelTypeStrings[ChannelType.FLOW_TOTAL] = 'Flow counter (Total)';
ChannelTypeStrings[ChannelType.FLOW_DAY] = 'Flow counter (Day)';
ChannelTypeStrings[ChannelType.FLOW_EXT_COMM] = 'Flow counter (Ext Comm.)';
ChannelTypeStrings[ChannelType.FLOW_LOGIC] = 'Flow counter (Logic)';

ChannelTypeStrings[ChannelType.RUNNING_TOTAL] = 'Running hour (Total)';
ChannelTypeStrings[ChannelType.RUNNING_DAY] = 'Running hour (Day)';
ChannelTypeStrings[ChannelType.RUNNING_LOGIC] = 'Running hour (Logic)';

ChannelTypeStrings[ChannelType.BLANK] = 'Blank';

ChannelTypeStrings[ChannelType.SYSTEM] = systemChannelType;

export enum SimpleTypes {
    Blank = 'Blank',
    NO = 'NO',
    NC = 'NC',
    M1 = 'M1',
    AI = 'AI',
    PT = 'PT',
    TR = 'TR',
    K = 'K',
    DV = 'DV',
    MT = 'MT',
    PU = 'PU',
    PUD = 'PUD',
    R1 = 'R1',
    R1D = 'R1D',
    SYS = 'SYS',
    EXT_AI = 'Ext-AI',
    EXT_DI = 'Ext-DI',
    EXT_PU = 'Ext-PU',
    L_AI = 'L-AI',
    L_DI = 'L-DI',
    L_PU = 'L-PU',
    L_R1 = 'L-R1',
}

export enum SpecialSimpleType {
    R = 'R',
    W = 'W',
    S = 'S',
}

export const MotorTypeStrings = {};
MotorTypeStrings[MotorChannelType.RUN] = 'RUN';
MotorTypeStrings[MotorChannelType.RUN_A] = 'RUN-A';
MotorTypeStrings[MotorChannelType.RUN_B] = 'RUN-B';
MotorTypeStrings[MotorChannelType.RUN_C] = 'RUN-C';
MotorTypeStrings[MotorChannelType.RUN_D] = 'RUN-D';
MotorTypeStrings[MotorChannelType.RUN_E] = 'RUN-E';
MotorTypeStrings[MotorChannelType.RUN_F] = 'RUN-F';
MotorTypeStrings[MotorChannelType.RUN_G] = 'RUN-G';
MotorTypeStrings[MotorChannelType.RUN_H] = 'RUN-H';
MotorTypeStrings[MotorChannelType.RUN_I] = 'RUN-I';
MotorTypeStrings[MotorChannelType.RUN_J] = 'RUN-J';
MotorTypeStrings[MotorChannelType.RUN_K] = 'RUN-K';

export const ChannelTypeStringLookup = {};
for (let type in ChannelTypeStrings) {
    ChannelTypeStringLookup[ChannelTypeStrings[type]] = Number(type);
}

export function getDigitalTypesSet() {
    return new Set([
        ChannelType.DIGITAL_CONTACT,
        ChannelType.DIGITAL_MOTOR,
        ChannelType.DIGITAL_EXT_COMM,
        ChannelType.DIGITAL_LOGIC,
    ]);
}

export function getAnalogTypesSet() {
    return new Set([
        ChannelType.ANALOG_420MA_AI,
        ChannelType.ANALOG_420MA_PT,
        ChannelType.ANALOG_1_5_V,
        ChannelType.ANALOG_PT100_3WIRE,
        ChannelType.ANALOG_PT100_2WIRE,
        ChannelType.ANALOG_TEMP_K,
        ChannelType.ANALOG_EXT_COMM,
        ChannelType.ANALOG_LOGIC,
    ]);
}

export function getRunningTypesSet() {
    return new Set([ChannelType.RUNNING_DAY, ChannelType.RUNNING_TOTAL, ChannelType.RUNNING_LOGIC]);
}

export function getFlowTypesSet() {
    return new Set([ChannelType.FLOW_DAY, ChannelType.FLOW_TOTAL, ChannelType.FLOW_EXT_COMM, ChannelType.FLOW_LOGIC]);
}

export function getExhaustTypesSet() {
    return new Set([ChannelType.EXH_GAS_DEV, ChannelType.EXH_GAS_MEAN]);
}

export function getAllTypesSet() {
    return new Set([
        ...getAnalogTypesSet(),
        ...getDigitalTypesSet(),
        ...getExhaustTypesSet(),
        ...getFlowTypesSet(),
        ...getRunningTypesSet(),
    ]);
}

const digitalTypes = getDigitalTypesSet();
const runningTypes = getRunningTypesSet();
const flowCoutnerTypes = getFlowTypesSet();
const analogTypes = getAnalogTypesSet();
const exhaustGasTypes = getExhaustTypesSet();

export function isBlank(type: string) {
    return ChannelTypeStrings[ChannelType.BLANK] === type;
}

export function isAnalog(type: ChannelType) {
    return analogTypes.has(type);
}

export function isDigital(type: ChannelType) {
    return digitalTypes.has(type);
}

export function isDigitalContact(type: ChannelType) {
    return type == ChannelType.DIGITAL_CONTACT;
}

export function isDigitalMotor(type: ChannelType) {
    return type == ChannelType.DIGITAL_MOTOR;
}

export function isRunningHour(type: ChannelType) {
    return runningTypes.has(type);
}

export function isFlowCounter(type: ChannelType) {
    return flowCoutnerTypes.has(type);
}

export function isExhaustGas(type: ChannelType) {
    return exhaustGasTypes.has(type);
}

export function isExhGasMean(type: ChannelType) {
    return type == ChannelType.EXH_GAS_MEAN;
}

export function isExhGasDev(type: ChannelType) {
    return type == ChannelType.EXH_GAS_DEV;
}

export function isSystemChannel(type: ChannelType) {
    return type == ChannelType.SYSTEM;
}

export function isSystemChannelByString(type: string) {
    return ChannelTypeStrings[ChannelType.SYSTEM] === type;
}

export function isAnalogByChannelTypeString(type: string) {
    return (
        ChannelTypeStrings[ChannelType.ANALOG_420MA_AI] === type ||
        ChannelTypeStrings[ChannelType.ANALOG_420MA_PT] === type ||
        ChannelTypeStrings[ChannelType.ANALOG_1_5_V] === type ||
        ChannelTypeStrings[ChannelType.ANALOG_PT100_3WIRE] === type ||
        ChannelTypeStrings[ChannelType.ANALOG_PT100_2WIRE] === type ||
        ChannelTypeStrings[ChannelType.ANALOG_TEMP_K] === type ||
        ChannelTypeStrings[ChannelType.ANALOG_EXT_COMM] === type ||
        ChannelTypeStrings[ChannelType.ANALOG_LOGIC] === type
    );
}

export function isAnalogSpecialTypeString(type: string) {
    return (
        ChannelTypeStrings[ChannelType.ANALOG_EXT_COMM] === type ||
        ChannelTypeStrings[ChannelType.ANALOG_LOGIC] === type
    );
}

export function isDigitalByChannelTypeString(type: string) {
    return (
        ChannelTypeStrings[ChannelType.DIGITAL_CONTACT] === type ||
        ChannelTypeStrings[ChannelType.DIGITAL_MOTOR] === type ||
        ChannelTypeStrings[ChannelType.DIGITAL_EXT_COMM] === type ||
        ChannelTypeStrings[ChannelType.DIGITAL_LOGIC] === type
    );
}

export function isDigitalMotorByChannelTypeString(type: string) {
    return ChannelTypeStrings[ChannelType.DIGITAL_MOTOR] === type;
}

export function isDigitalWOMotorByChannelTypeString(type: string) {
    return (
        ChannelTypeStrings[ChannelType.DIGITAL_CONTACT] === type ||
        ChannelTypeStrings[ChannelType.DIGITAL_EXT_COMM] === type ||
        ChannelTypeStrings[ChannelType.DIGITAL_LOGIC] === type
    );
}

export function isRunningHourByChannelTypeString(type: string) {
    return (
        ChannelTypeStrings[ChannelType.RUNNING_DAY] === type ||
        ChannelTypeStrings[ChannelType.RUNNING_TOTAL] === type ||
        ChannelTypeStrings[ChannelType.RUNNING_LOGIC] === type
    );
}

export function isFlowCounterByChannelTypeString(type: string) {
    return (
        ChannelTypeStrings[ChannelType.FLOW_DAY] === type ||
        ChannelTypeStrings[ChannelType.FLOW_TOTAL] === type ||
        ChannelTypeStrings[ChannelType.FLOW_EXT_COMM] === type ||
        ChannelTypeStrings[ChannelType.FLOW_LOGIC] === type
    );
}

export function isExhGasMeanByChannelTypeString(type: string) {
    return ChannelTypeStrings[ChannelType.EXH_GAS_MEAN] === type;
}

export function isExhGasDevByChannelTypeString(type: string) {
    return ChannelTypeStrings[ChannelType.EXH_GAS_DEV] === type;
}

export function isSystemChannelTypeString(type: string) {
    return ChannelTypeStrings[ChannelType.SYSTEM] === type;
}

export function isRunType(type: string, motorChannel: MotorChannelType): boolean {
    return MotorTypeStrings[motorChannel] === type;
}

export const channelTypesSelector = [
    { name: 'channel.type.digital', allowedChannels: getDigitalTypesSet() },
    { name: 'channel.type.analog', allowedChannels: getAnalogTypesSet() },
    { name: 'channel.type.exhaust', allowedChannels: getExhaustTypesSet() },
    { name: 'channel.type.flow', allowedChannels: getFlowTypesSet() },
    { name: 'channel.type.running', allowedChannels: getRunningTypesSet() },
];
